import * as React from 'react';
import { useTripStore } from 'pages/tracking-v2/trip-details-page/hooks';
import { cn } from 'lib/utils';

import { InvoiceIListItem, InvoiceListItemSkeleton } from './invoice-list-item';

type Props = React.ComponentProps<'div'> & {
  classNames?: {
    listItem?: string;
  };
};

export const InvoicesList = ({ className, classNames, ...props }: Props) => {
  const { trip } = useTripStore();
  const invoices = trip?.invoices;

  return (
    <div className={cn('flex flex-col gap-6', className)} {...props}>
      {!invoices && (
        <>
          <InvoiceListItemSkeleton />
          <InvoiceListItemSkeleton />
          <InvoiceListItemSkeleton />
        </>
      )}
      {invoices?.map((invoice) => (
        <InvoiceIListItem
          key={invoice.id}
          invoice={invoice}
          className={classNames?.listItem}
        />
      ))}
    </div>
  );
};
